module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"dialog\" class=\"customFonts\" title=\"Custom Fonts\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <table id=\"propMainTable\"></table>\r\n         </div>\r\n    </div>\r\n    <div class=\"row\" style=\"margin-top:4px;\">\r\n        <div class=\"col-md-12\">\r\n            <button class=\"btn btn-default btn-sm pf-btn-small itemNew\">Add</button>\r\n            <button class=\"btn btn-default btn-sm pf-btn-small itemRemove\">Remove</button>\r\n            <button class=\"btn btn-default btn-sm pf-btn-small itemUp\">Up</button>\r\n            <button class=\"btn btn-default btn-sm pf-btn-small itemDown\">Down</button>\r\n        </div>     \r\n    </div>    \r\n</div>")
  }
  return __output;

}